import Header from "@/components/header";
import {
  Container,
  Group,
  Loader,
  Stack,
  Table,
  Text,
  Title,
} from "@mantine/core";

import { useGetServicePrices } from "@/services/servicePrice/hooks/useGetServicePrices";

function ServicePrice() {
  const { data, isLoading } = useGetServicePrices();
  const rows = data?.map((element) => (
    <Table.Tr key={element.order}>
      <Table.Td>
        <Text size="xs">{element.title}</Text>
      </Table.Td>
      <Table.Td>
        <Group wrap="nowrap" gap="5" justify="center">
          <Text size="xs" fw="800">
            {element?.price?.toLocaleString()}
          </Text>
          <Text size="xs">ریال</Text>
        </Group>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <>
      <Header title="تعرفه پیامکی" showBack route="/dashboard/profile" />
      <Container w="100%" size="md">
        <Title order={4}> تعرفه پیامکی</Title>
        <Stack>
          <Stack px="lg" flex={1} mt="xl">
            <Text fw="500">لیست قیمت خدمات پیامکی</Text>
            <Stack gap="0">
              <Text size="sm" ta="justify">
                در این صفحه می‌توانید قیمت خدمات پیامکی مختلف را مشاهده کنید. هر
                یک از خدمات ارائه شده برای نیازهای خاصی طراحی شده‌اند و قیمت‌ها به
                ازای هر پیامک محاسبه می‌شوند.
              </Text>
              <Text size="sm" ta="justify">
                جزئیات مربوط به هر خدمت نیز در جدول زیر آورده شده است تا بتوانید
                با توجه به نیاز خود بهترین گزینه را انتخاب کنید. این خدمات شامل
                ارسال پیامک‌های منطقه‌ای، پیامک‌های کد تخفیف و پیامک‌های سفارشی
                مشتریان هستند.{" "}
              </Text>
              <Text size="sm" ta="justify">
                لطفاً توجه داشته باشید که تمامی قیمت‌ها به ریال بوده و ممکن است
                بسته به تغییرات نرخ‌ها به‌روزرسانی شوند. برای اطلاعات بیشتر و یا
                سفارش، می‌توانید با تیم پشتیبانی ما در ارتباط باشید.
              </Text>
            </Stack>
            {isLoading ? (
              <Group justify="center">
                <Loader type="dots" size="xs" />
              </Group>
            ) : (
              <Table striped highlightOnHover withTableBorder withColumnBorders>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th ta="center"> خدمات</Table.Th>
                    <Table.Th ta="center"> قیمت </Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>{rows}</Table.Tbody>
              </Table>
            )}
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

export default ServicePrice;
